<!-- tab导航和搜索 -->
<template>
  <div class="component-header">
    <!-- <div class="banner">
      <ul>
        <li
          class="def-hover-trs"
          :class="{ active: leftNavIndex == 1 || menutype == 1 }"
          @click="changemenu(1)"
        >
          文章
        </li>
        <li
          class="def-hover-trs"
          @click="changemenu(2)"
          :class="{ active: leftNavIndex == 2 || menutype == 2 }"
        >
          绘画
        </li>
        <li
          class="def-hover-trs"
          @click="changemenu(3)"
          :class="{ active: leftNavIndex == 3 || menutype == 3 }"
        >
          摄影
        </li>
        <li
          class="def-hover-trs"
          @click="changemenu(4)"
          :class="{ active: leftNavIndex == 4 || menutype == 4 }"
        >
          微视频
        </li>
      </ul>
      <div class="search-wrap">
        <input
          class="search-input"
          type="text"
          v-model="searchKeyword"
          @keyup.enter="onClickSearch"
          placeholder="请输入内容"
        />
        <span class="search-btn def-hover-trs" @click="onClickSearch"
          >搜索</span
        >
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ComponentHeader",
  data() {
    return {
      isphone: false,
      searchKeyword: "",
      menutype: 1 //默认是文章
    };
  },
  props: ["webtype"],
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex", // 当前激活的导航菜单的下标
      "leftNavIndex" //四个类型的作品类型下标
    ])
  },
  mounted() {
    // if (this.isMobile()) {
    //   this.isphone = true;
    // } else {
    //   this.isphone = false;
    // }
    this.menutype = this.$route.query.type ? this.$route.query.type : 1;
    this.$store.commit("updateLeftNavIndex", this.menutype);
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    changemenu(menutype) {
      this.menutype = menutype;
      this.$store.commit("updateLeftNavIndex", menutype);
      this.searchKeyword = "";
      this.$store.commit("updatesearchword", this.searchKeyword);
      // 判断是列表页还是详情页
      if (this.webtype == "detail") {
        this.$router.push({
          name: "publicvoting",
          query: {
            type: this.menutype
          }
        });
      }
    },
    /**
     * ##########################################################################################
     * @description 点击了搜索按钮
     * ##########################################################################################
     */

    onClickSearch() {
      // if(this.searchKeyword) {
      //   // 显示搜索结果对话框
      //   this.$router.push({
      //     name: 'list-of-martyrs-search',
      //     query: {
      //       word: this.searchKeyword
      //     }
      //   })
      // }
      // else {
      //   this.$message.error('请输入英烈名字');
      // }
      // 显示搜索结果对话框 searchword
      // this.$refs['MartyrSearchResultDialog'].show()
      // 更新搜索的作品名称
      this.$store.commit("updatesearchword", this.searchKeyword);
      this.$store.commit("updateLeftNavIndex", this.menutype);
      // 显示搜索结果对话框
      this.$router.push({
        name: "publicvoting",
        query: {
          type: this.menutype,
          word: this.searchKeyword
        }
      });
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.component-header {
  position: relative;
  height: 70px;
  min-width: 1200px;
  margin-top: 60px;
  border-bottom: solid 1px #cfc1b9;
}
.active {
  background-color: var(--main-color);
  color: #fff !important;
}
.banner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.banner ul {
  width: 520px;
  background-image: linear-gradient(#fbe1cf, #fbdac5, #f0c9b9);
  display: flex;
  justify-content: space-between;
}
.banner ul li {
  width: 130px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 26px;
  color: var(--main-color);
}
.banner ul li:hover {
  background-color: var(--main-color);
  color: #fff;
}
.search-wrap {
  width: 320px;
  height: 48px;
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.78);
  border-radius: 3px;
  overflow: hidden;
  background-color: rgba(216, 191, 81, 0.78);
}

.search-input {
  flex: 1;
  font-size: 16px;
  border: 7px solid #fadece;
  outline: none;
  color: #000;
  padding: 0 5px;
  overflow: hidden;
}

.search-input::placeholder {
  color: rgba(119, 119, 119, 0.8);
}

.search-btn {
  width: 75px;
  flex-shrink: 0;
  background: #fadece;
  font-size: 18px;
  font-weight: bold;
  color: var(--main-color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  height: 52px;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 16px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}

.navs {
  width: 100%;
  height: 58px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(109, 3, 4, 0.9);
  z-index: 20;
}

.navs .main-content {
  height: 100%;
  display: flex;
}

.navs .link {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.4s;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 16px;
  position: relative;
}

.navs .link:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.navs .link::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  left: 0;
  top: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s;
}

.navs .link:hover {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link:hover::after {
  opacity: 1;
  transform: scale(1);
}

.navs .link.active {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link.active::after {
  opacity: 1;
  transform: scale(1);
}

.has-login-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.has-login-wrapper .link-mine {
  color: #f7f17d;
  font-weight: bold;
  margin-right: 16px;
}

.has-login-wrapper .userinfo {
  display: flex;
  align-items: center;
}

.has-login-wrapper .avatar {
  width: 48px;
  height: 48px;
  border: 2px solid #fbd48b;
  margin-right: 8px;
  cursor: pointer;
}

.has-login-wrapper .nickname {
  color: #ffffff;
}
.has-login-wrapper .logouts {
  color: #bb1515;
  border: solid 1px #ef7878;
  padding: 3px;
  background-color: #eae3b6;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.has-login-wrapper .logouts:hover {
  color: #e72c2c;
}
.has-login-wrapper .logouts:active {
  color: #9b2020;
}
</style>



// WEBPACK FOOTER //
// src/components/tabsearch.vue